/**
 * Severity levels for lint findings, ordered by triage priority.
 * @enum {string}
 */
export const LINT_SEVERITY = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

/**
 * Stable machine codes for each analyzer finding. Surfaced in the UI pin label
 * and used by tests to assert on findings without depending on message copy.
 * @enum {string}
 */
export const LINT_CODE = {
  CONTRADICTION: 'CONTRADICTION',
  DUPLICATE: 'DUPLICATE',
  ALWAYS_TRUE: 'ALWAYS_TRUE',
  ALWAYS_FALSE: 'ALWAYS_FALSE',
  SUSPICIOUS_LITERAL: 'SUSPICIOUS_LITERAL',
  INVALID_COLLECTION_ARG: 'INVALID_COLLECTION_ARG',
};

export const FIELD_PATH_RE = /^[A-Za-z_][\w]*(?:\.[A-Za-z_][\w]*)*$/;

/**
 * Pattern matching string literal values that look like debugging leftovers.
 * Anchored at the start so values that merely contain these words are ignored.
 */
export const SUSPICIOUS_LITERAL_RE = /^(test|tesss|no-test|asdf|xxx)/i;

/**
 * Equality-forcing operator that pins a path to exactly one constant. Used by
 * the contradiction analyzer: two different forced constants under one AND can
 * never both hold.
 */
export const EQUALITY_OPERATOR = '==';
